import "../CSS/TermsAndConditions.css";
import NavBar from "./NavBar";
import Footer from "./Footer";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
    const [showArrow, setShowArrow] = useState(false);

    // Handle scroll events
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowArrow(true);
                console.log("scroll event");
            } else {
                setShowArrow(false);
                console.log("scroll event false");
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Scroll to the top of the page
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    return (
        <div>
            <Helmet>
                <title>Anglofone | Refund Policy</title>
                <meta name="description" content="AngloFone is the best online educational firm that teaches people in all walks of life to speak English in a way that eases the learning process." />
            </Helmet>
            <NavBar />
            <div className="terms-container">
                <h1 className="terms-heading">Refund<span> Policy
                </span></h1>
                <div className="custom-underline"></div>
                <p className="company-name">AngloFone EdTech Pvt. Ltd</p>

               

                <p className="intro">
                Thank you for choosing AngloFone EdTech Pvt. Ltd for your educational needs. We appreciate your trust in our services. This Refund Policy explains the terms and conditions under which refunds are provided by AngloFone EdTech Pvt. Ltd.
                </p>

                <div className="terms-content">
                    <section>
                        <h2>1. Refund Eligibility</h2>

                        <ul>
                            <li>
                                <p>Valid Reasons: Refunds will be considered only for valid reasons, including but not limited to:
                                    <ul>
                                        <li>Technical issues preventing course access.</li>
                                        <li>Unforeseen personal circumstances preventing participation.</li>
                                        <li>If under any circumstances, a course has to be discontinued from our side, learners will be eligible for a refund. The refund will be processed for the portion of the course that remains unused.</li>
                                    </ul>
                                </p>
                            </li>
                            
                        </ul>


                    </section>

  

                    <section>
                        <h2>2. Course Cancellation</h2>
                        <ul>
                            <li>
                                <p>
                                We will make all reasonable efforts to notify affected individuals of the course cancellation and process the refund in a timely manner.
                                </p>
                            </li>

                        </ul>


                    </section>


                    <section>
                        <h2>3. Contact Information</h2>
                        <ul>
                            <li>
                                <p>
                                For refund inquiries or to submit a refund request, please contact [manager@anglofone.co.in].
                                </p>
                            </li>
                        </ul>

                    </section>

                    <section>
                        <h2>4. Policy Changes</h2>
                        <ul>
                            <li>
                                <p>
                                AngloFone EdTech Pvt. Ltd reserves the right to modify or amend this Refund Policy at any time. Any changes will be effective immediately upon posting on our website.
                                </p>
                            </li>
                            
                        </ul>


                    </section>
                    {showArrow && (
    <button
        className="back-to-top"
        onClick={scrollToTop}
        aria-label="Back to top"
    >
        ↑
    </button>
)}

                   
                </div>

                <p className="conclusion">
                By enrolling in a course with AngloFone EdTech Pvt. Ltd, you acknowledge and agree to the terms of this Refund Policy.
                </p>
                <p className="conclusion">Thank you for choosing AngloFone EdTech Pvt Ltd.</p>
            </div>
            <footer>
                <Footer />
            </footer>
        </div>
    );
};

export default RefundPolicy;
